export default __webpack_public_path__ + "static/media/details_icon.b420ff17.svg";